module.exports = __webpack_public_path__ + "images/emoji/up.68537c62c1fc0ece6e21.png";